<template>
  <div>
    <signup-purchase v-if="openSignupPurchase"
                     :event-to-emit="eventToEmit" />
    <buyer-purchase v-if="openBuyerInfo" />
    <basic-info-purchase v-if="openBasicInfoPurchase"
                         :event-to-emit-basic="eventToEmitBasic" />
    <user-profile-onboarding v-if="openUserProfilePurchase"
                             :purchase="true" />
  </div>
</template>

<script>
import { purchase } from '@/plugins/mixins/purchase.js'
import BasicInfoPurchase from '@/components/basic-info-purchase/BasicInfoPurchase.vue'
import SignupPurchase from '@/components/signup-purchase/SignupPurchase.vue'
import UserProfileOnboarding from '@/components/user-profile-onboarding/UserProfileOnboarding.vue'
import BuyerPurchase from '@/components/buyer-purchase/BuyerPurchase.vue'

export default {
  components: {
    BasicInfoPurchase,
    SignupPurchase,
    UserProfileOnboarding,
    BuyerPurchase
  },
  mixins: [purchase],
  props: {
    eventToEmit: {
      type: String,
      default: 'closeSignupPurchase'
    },
    eventToEmitBasic: {
      type: String,
      default: 'closeBasicInfoPurchase'
    },
    purchaseModel: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      openBasicInfoPurchase: false,
      openSignupPurchase: false,
      openBuyerInfo: false,
      openUserProfilePurchase: false,
      createdBuyer: false
    }
  },
  created() {
    this.$root.$on('openSignupPurchase', () => {
      this.openSignupPurchase = true
    })
    this.$root.$on('closeSignupPurchase', () => {
      this.openSignupPurchase = false
      this.createPurchase()
    })
    this.$root.$on('closeSignupPurchaseNoCreate', () => {
      this.openSignupPurchase = false
    })
    this.$root.$on('openBuyerInfo', () => {
      this.openBuyerInfo = true
    })
    this.$root.$on('closeBuyerInfo', () => {
      if (this.createdBuyer) {
        return
      }
      this.createdBuyer = true
      this.openBuyerInfo = false
      this.createPurchase(this.purchaseModel, true)
    })
    this.$root.$on('closeBuyerInfoNoCreate', () => {
      this.openBuyerInfo = false
    })
    this.$root.$on('openBasicInfoPurchase', () => {
      this.openBasicInfoPurchase = true
    })
    this.$root.$on('closeBasicInfoPurchase', () => {
      this.openBasicInfoPurchase = false
      this.createPurchase()
    })
    this.$root.$on('closeBasicInfoPurchaseNoCreate', () => {
      this.openBasicInfoPurchase = false
    })
    this.$root.$on('openUserProfilePurchase', () => {
      this.openUserProfilePurchase = true
    })
    this.$root.$on('closeUserProfilePurchase', () => {
      this.openUserProfilePurchase = false
      this.createPurchase()
    })
    this.$root.$on('closeUserProfileOnboarding', () => {
      this.openUserProfilePurchase = false
    })
  }
}
</script>

<style>
</style>
